module.exports = __webpack_public_path__ + "img/order_cancel.1114d563.gif";